/* ==========================================================================
   assets/no-ba-auto-1015.js. NEW FILE (15 Oct 2026). Before / after sliders that sweep by themselves.
   Bon: on a phone the drag sliders were hard to move and a sideways swipe left the whole in-app browser.
   Works on every [data-comparison] frame inside #no-advcoti and #no-dfb31 (the drag code in each page's
   lander js stays; this file only moves the same range input and fires its "input" event).
   - Touch devices and in-app browsers (TikTok, Instagram, Facebook and others): no drag at all. The divider
     sweeps from WITHOUT to WITH and back on its own (4.5 s each way, eased), a tap on the picture pauses or
     resumes it, and the picture only allows vertical page scroll (touch-action: pan-y), so a sideways finger
     move can never start a drag or a browser back or app exit gesture.
   - Mouse: the drag stays, with the same gentle sweep until the visitor first grabs or keys the slider.
   - prefers-reduced-motion: no sweep; the WITHOUT and WITH labels become a two button toggle.
   - The sweep pauses while the picture is off screen.
   NO EM DASHES OR EN DASHES ANYWHERE IN THIS FILE.
   ========================================================================== */
(function () {
  "use strict";
  var UA = navigator.userAgent || "";
  var IN_APP = /(TikTok|musical_ly|Bytedance|trill_|Instagram|FBAN|FBAV|FB_IAB|FBIOS|FB4A|Messenger|Snapchat|Pinterest|LinkedInApp|Line\/|Twitter|GSA\/)/i.test(UA);
  function mq(q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } }
  var TOUCH = IN_APP || mq("(pointer: coarse)") || mq("(hover: none)");
  var REDUCED = mq("(prefers-reduced-motion: reduce)");
  var HALF = 4500, AMP = 44;                      /* ms per direction, percent either side of the middle */

  function frames() {
    return Array.prototype.slice.call(document.querySelectorAll("#no-advcoti [data-comparison], #no-dfb31 [data-comparison]"));
  }
  function setValue(f, v) {
    var input = f.querySelector("input[type=range]");
    if (!input) return;
    input.value = String(v);
    input.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function setup(f) {
    if (f.getAttribute("data-ba")) return;
    var input = f.querySelector("input[type=range]");
    if (!input || !f.querySelector("[data-before-layer]")) return;
    input.step = "any";
    f.setAttribute("data-ba", TOUCH ? "touch" : "mouse");
    var st = { run: !REDUCED, visible: false, t: 0, last: 0, user: false };
    f.__ba = st;
    if (TOUCH) {
      f.style.touchAction = "pan-y";
      input.style.touchAction = "pan-y";
      input.style.pointerEvents = "none";
      input.setAttribute("tabindex", "-1");
    }
    function paint() { f.setAttribute("data-ba-state", REDUCED ? "still" : (st.run && !st.user ? "playing" : "paused")); }

    if (REDUCED) {
      /* toggle: the two corner labels become buttons */
      var labs = f.querySelectorAll(".justify-between > span");
      if (labs.length === 2) {
        var row = labs[0].parentNode;
        row.classList.add("ba-toggle");
        [100, 0].forEach(function (v, i) {
          var b = labs[i];
          b.setAttribute("role", "button"); b.setAttribute("tabindex", "0"); b.classList.add("ba-lab");
          function pick(e) { if (e) { e.preventDefault(); e.stopPropagation(); } setValue(f, v); labs[0].setAttribute("aria-pressed", v === 100 ? "true" : "false"); labs[1].setAttribute("aria-pressed", v === 0 ? "true" : "false"); }
          b.addEventListener("click", pick);
          b.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") pick(e); });
        });
        setValue(f, 100); labs[0].setAttribute("aria-pressed", "true"); labs[1].setAttribute("aria-pressed", "false");
        if (TOUCH) {
          f.addEventListener("click", function (e) {
            if (e.target.closest && e.target.closest("button, a, [role=button]")) return;
            var cur = Number(input.value); var v = cur > 50 ? 0 : 100;
            setValue(f, v); labs[0].setAttribute("aria-pressed", v === 100 ? "true" : "false"); labs[1].setAttribute("aria-pressed", v === 0 ? "true" : "false");
          });
        }
      }
      paint();
      return;
    }

    if (TOUCH) {
      /* a tap pauses or resumes; a finger that travelled (a scroll or a sideways swipe) never counts as a tap */
      var sx = 0, sy = 0, moved = false;
      f.addEventListener("pointerdown", function (e) { sx = e.clientX; sy = e.clientY; moved = false; }, { passive: true });
      f.addEventListener("pointermove", function (e) { if (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10) moved = true; }, { passive: true });
      f.addEventListener("click", function (e) {
        if (e.target.closest && e.target.closest("button, a, [role=button]")) return;   /* Highlight / Outline keep working */
        if (moved) { moved = false; return; }
        st.run = !st.run; st.last = 0; paint();
      });
    } else {
      /* mouse: the first real grab or key press hands the slider to the visitor for good */
      var stop = function (e) { if (e && e.isTrusted === false) return; st.user = true; paint(); };
      input.addEventListener("pointerdown", stop);
      input.addEventListener("keydown", stop);
      input.addEventListener("input", function (e) { if (e.isTrusted) stop(e); });
    }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (es) { es.forEach(function (en) { st.visible = en.isIntersecting; st.last = 0; }); }, { threshold: 0.15 }).observe(f);
    } else { st.visible = true; }
    paint();
  }

  function loop(now) {
    frames().forEach(function (f) {
      var st = f.__ba;
      if (!st || REDUCED || st.user || !st.run || !st.visible) { if (st) st.last = 0; return; }
      if (st.last) st.t += Math.min(100, now - st.last);
      st.last = now;
      /* cosine: eased at both ends, starts on WITHOUT (high value = more of the tube alone) */
      setValue(f, 50 + AMP * Math.cos(Math.PI * st.t / HALF));
    });
    window.requestAnimationFrame(loop);
  }

  function boot() {
    frames().forEach(setup);
    var cap = Array.prototype.slice.call(document.querySelectorAll("#no-advcoti p, #no-dfb31 p")).filter(function (p) { return /^\s*drag to compare\s*$/i.test(p.textContent); });
    cap.forEach(function (p) {
      if (REDUCED) p.textContent = "Tap Without or With to switch";
      else if (TOUCH) p.textContent = "Comparing on its own. Tap a picture to pause";
    });
    document.documentElement.setAttribute("data-ba-mode", (REDUCED ? "reduced-" : "") + (TOUCH ? "touch" : "mouse") + (IN_APP ? "-inapp" : ""));
    if (!REDUCED) window.requestAnimationFrame(loop);
  }
  function later() { setTimeout(boot, 60); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", later); else later();
})();
